angular
   .module('vppApp')
   .service('ViewFinderService', ViewFinderService);

  ViewFinderService.$inject = ['$window'];

  function ViewFinderService($window) {

  		this.viewName = angular.element(document).find('[ui-view]').data('$uiView');
  		return;
  		console.log("view name is " + viewName);
  	
  }